export const CALL_SITUATION_LIST = [{ // 接口调用情况
    titleImg: require('../../../../assets/images/other-tenant-total-count.png'),
    title: '总调用频次',
    count: 'allTotalCount',
    increase: 'allTotalCountGrowth',
    percentage: 'allTotalCountGrowthRate'
},
{
    titleImg: require('../../../../assets/images/other-tenant-total-success.png'),
    title: '成功调用频次',
    count: 'allSuccessCount',
    increase: 'allSuccessCountGrowth',
    percentage: 'allSuccessCountGrowthRate'
},
{
    titleImg: require('../../../../assets/images/other-tenant-total-fail.png'),
    title: '异常调用频次',
    count: 'allFailCount',
    increase: 'allFailCountGrowth',
    percentage: 'allFailCountGrowthRate'
}];

export const MIDDLE_TABLE_LIST = [ // 中间表数据处理情况
    {
        labelImg: require('../../../../assets/images/middle-table-icon1.png'),
        labelTitle: 'Batch表采集量',
        count: 'maxId',
        percentage: 'batchCollectGrowRate'
    },
    {
        labelImg: require('../../../../assets/images/middle-table-icon2.png'),
        labelTitle: 'Batch表处理量',
        count: 'currentJobId',
        percentage: 'batchCurrGrowRate'
    },
    {
        labelImg: require('../../../../assets/images/middle-table-icon3.png'),
        labelTitle: 'Batch表未处理量',
        count: 'undisposedCount',
        percentage: 'undisposedGrowRate'
    },
    {
        labelImg: require('../../../../assets/images/middle-table-icon4.png'),
        labelTitle: 'Batch表处理失败统计',
        count: 'failCount',
        percentage: 'failGrowRate'
    }
];

export const TENANT_CODE_LIST = { // 内外销租户对照
    '88.182.100': '3',
    '88.182.101': '4'
};